export const QueryKeys = {
  ROLES_DETAILS: 'rolesDetails',
} as const;
